import GlobalStorage from 'lib/GlobalStorage'

export default new GlobalStorage('__BUYMA_PARTNERS__')
